import { useState } from 'react';
import { Input } from './Input';
import { parseAmountInput, formatAmountInput } from './fieldData';
export function AmountField({
  label,
  value,
  currency,
  onChange,
  disabled,
  error,
  helper,
}: {
  label: string;
  value: string;
  currency: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
  helper?: string;
}) {
  const [touched, setTouched] = useState(false);
  const result = parseAmountInput(value, currency);
  return (
    <div data-slot="amount-field">
      <Input
        label={label}
        value={value}
        disabled={disabled}
        inputMode="decimal"
        autoComplete="off"
        maxLength={64}
        className="tabular-nums"
        placeholder="0,00"
        error={error || (touched ? result.error || undefined : undefined)}
        helper={helper}
        errorTone="strong"
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => {
          setTouched(true);
          if (result.minorUnits !== null && !result.error)
            onChange(formatAmountInput(result.minorUnits, currency));
        }}
      />
    </div>
  );
}
